import { useMemo } from 'react';
import * as web3 from '@ywwwtseng/web3';
import { useBalance as useWalletKitBalance, type Token } from '@ywwwtseng/wallet-kit';
import { useBalance as useTonWalletKitBalance } from '@ywwwtseng/ton-wallet-kit';

export const useBalance = (token?: Token | null) => {
  const balance0 = useWalletKitBalance(token);
  const balance1 = useTonWalletKitBalance(token);


  const value = useMemo(() => {
    return balance0 ?? balance1 ?? '0';
  }, [balance0, balance1]);

  const formatted = useMemo(() => {
    if (!token) {
      return '0';
    }
    return web3.utils.formatUnits(value, token.decimals);
  }, [value, token]);

  return {
    value,
    formatted,
  };
};
